var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    [
      _c("li", [
        _c("h3", [_vm._v(_vm._s(_vm.t("health", "General settings")))])
      ]),
      _vm._v(" "),
      _c("li", [_c("h4", [_vm._v(_vm._s(_vm.t("health", "Age")))])]),
      _vm._v(" "),
      _c("ActionInput", {
        attrs: { type: "number", value: _vm.person.age, icon: "icon-user" },
        on: { submit: _vm.updateAge }
      }),
      _vm._v(" "),
      _c("li", [
        _c("h4", [
          _vm._v(_vm._s(_vm.t("health", "Size"))),
          _c("span", [_vm._v(_vm._s(_vm.t("health", "in cm")))])
        ])
      ]),
      _vm._v(" "),
      _c("ActionInput", {
        attrs: {
          type: "number",
          value: _vm.person.size,
          icon: "icon-fullscreen"
        },
        on: { submit: _vm.updateSize }
      }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "ActionRadio",
        {
          attrs: {
            name: "sex",
            value: "female",
            checked: _vm.person.sex === "female"
          },
          on: {
            change: function($event) {
              return _vm.updateSex("female")
            }
          }
        },
        [_vm._v("\n\t\tfemale\n\t")]
      ),
      _vm._v(" "),
      _c(
        "ActionRadio",
        {
          attrs: {
            name: "sex",
            value: "male",
            checked: _vm.person.sex === "male"
          },
          on: {
            change: function($event) {
              return _vm.updateSex("male")
            }
          }
        },
        [_vm._v("\n\t\tmale\n\t")]
      ),
      _vm._v(" "),
      _c("li", [_c("h4", [_vm._v(_vm._s(_vm.t("health", "Currency")))])]),
      _vm._v(" "),
      _c("ActionInput", {
        attrs: { value: _vm.person.currency, icon: "icon-rename" },
        on: {
          submit: function($event) {
            return _vm.$store.dispatch("setValue", {
              key: "currency",
              value: $event.target[1].value
            })
          }
        }
      }),
      _vm._v(" "),
      _c("li", [_c("h3", [_vm._v(_vm._s(_vm.t("health", "Manage modules")))])]),
      _vm._v(" "),
      _vm.person
        ? _c(
            "ActionCheckbox",
            {
              attrs: {
                checked: _vm.person.enabledModuleWeight,
                value: "weight"
              },
              on: {
                change: function($event) {
                  return _vm.$store.dispatch("setValue", {
                    key: "enabledModuleWeight",
                    value: $event.target.checked
                  })
                }
              }
            },
            [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Weight")) + "\n\t")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.person
        ? _c(
            "ActionCheckbox",
            {
              attrs: {
                checked: _vm.person.enabledModuleFeeling,
                value: "feeling"
              },
              on: {
                change: function($event) {
                  return _vm.$store.dispatch("setValue", {
                    key: "enabledModuleFeeling",
                    value: $event.target.checked
                  })
                }
              }
            },
            [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Feeling")) + "\n\t")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.person
        ? _c(
            "ActionCheckbox",
            {
              attrs: {
                checked: _vm.person.enabledModuleMeasurement,
                value: "measurement"
              },
              on: {
                change: function($event) {
                  return _vm.$store.dispatch("setValue", {
                    key: "enabledModuleMeasurement",
                    value: $event.target.checked
                  })
                }
              }
            },
            [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Measurement")) + "\n\t")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.person
        ? _c(
            "ActionCheckbox",
            {
              attrs: {
                checked: _vm.person.enabledModuleActivities,
                value: "activities"
              },
              on: {
                change: function($event) {
                  return _vm.$store.dispatch("setValue", {
                    key: "enabledModuleActivities",
                    value: $event.target.checked
                  })
                }
              }
            },
            [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Activities")) + "\n\t")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.person && false
        ? _c(
            "ActionCheckbox",
            {
              attrs: {
                checked: _vm.person.enabledModuleBreaks,
                value: "breaks"
              },
              on: {
                change: function($event) {
                  return _vm.$store.dispatch("setValue", {
                    key: "enabledModuleBreaks",
                    value: $event.target.checked
                  })
                }
              }
            },
            [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Breaks")) + "\n\t")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.person && false
        ? _c(
            "ActionCheckbox",
            {
              attrs: {
                checked: _vm.person.enabledModuleMedicine,
                value: "medicine"
              },
              on: {
                change: function($event) {
                  return _vm.$store.dispatch("setValue", {
                    key: "enabledModuleMedicine",
                    value: $event.target.checked
                  })
                }
              }
            },
            [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Medicine")) + "\n\t")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.person && false
        ? _c(
            "ActionCheckbox",
            {
              attrs: {
                checked: _vm.person.enabledModuleActivities,
                value: "activities"
              },
              on: {
                change: function($event) {
                  return _vm.$store.dispatch("setValue", {
                    key: "enabledModuleActivities",
                    value: $event.target.checked
                  })
                }
              }
            },
            [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Activities")) + "\n\t")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.person
        ? _c(
            "ActionCheckbox",
            {
              attrs: { checked: _vm.person.enabledModuleSleep, value: "sleep" },
              on: {
                change: function($event) {
                  return _vm.$store.dispatch("setValue", {
                    key: "enabledModuleSleep",
                    value: $event.target.checked
                  })
                }
              }
            },
            [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Sleep")) + "\n\t")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.person && false
        ? _c(
            "ActionCheckbox",
            {
              attrs: {
                checked: _vm.person.enabledModuleNutrition,
                value: "nutrition"
              },
              on: {
                change: function($event) {
                  return _vm.$store.dispatch("setValue", {
                    key: "enabledModuleNutrition",
                    value: $event.target.checked
                  })
                }
              }
            },
            [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Nutrition")) + "\n\t")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.person
        ? _c(
            "ActionCheckbox",
            {
              attrs: {
                checked: _vm.person.enabledModuleSmoking,
                value: "smoking"
              },
              on: {
                change: function($event) {
                  return _vm.$store.dispatch("setValue", {
                    key: "enabledModuleSmoking",
                    value: $event.target.checked
                  })
                }
              }
            },
            [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Smoking")) + "\n\t")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [_c("h4", [_vm._v("Sex")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }